import React from 'react';
import '../../Shared/Category/style.css'


export default function InputWithIcon(props) {
  return (
    <div>
      <label tabIndex={0} htmlFor="inlineFormInputGroup">
        <div className="input-group">
          <div className="input-group-prepend ">
            <div className="input-group-text amounttext">$</div>
                  </div>                                 
                      <input type="number" inputMode='numeric' pattern="[0-9]*" className="form-control icontext" onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 110)
                          && e.preventDefault()} {...props} /> 
                                                            
        </div>
      </label>
    </div>);
}